module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-island-kitchen-960-024ea6e3.jpg";